__turbopack_context__.v({
  "copy": "TalesBlockParagraph-module-scss-module__N6cLTG__copy",
  "fade-in": "TalesBlockParagraph-module-scss-module__N6cLTG__fade-in",
  "inner": "TalesBlockParagraph-module-scss-module__N6cLTG__inner",
  "isAboveFold": "TalesBlockParagraph-module-scss-module__N6cLTG__isAboveFold",
  "isBoldTheme": "TalesBlockParagraph-module-scss-module__N6cLTG__isBoldTheme",
  "isInView": "TalesBlockParagraph-module-scss-module__N6cLTG__isInView",
  "root": "TalesBlockParagraph-module-scss-module__N6cLTG__root",
});
